import React from "react";
import CommentSection from "./CommentSection";

function formatRelativeTime(timestamp) {
  if (!timestamp) return "Just now";

  const now = new Date();
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) return "Just now";
  if (diffInSeconds < 3600) {
    const mins = Math.floor(diffInSeconds / 60);
    return `${mins} ${mins === 1 ? "minute" : "minutes"} ago`;
  }
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  }
  if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} ${days === 1 ? "day" : "days"} ago`;
  }

  return date.toLocaleDateString();
}

function PostDetail({ post, category, onBack, user }) {
  return (
    <div className="post-detail-container">
      <div className="post-detail-header">
        <button className="back-btn" onClick={onBack}>
          <span>←</span> Back to {category.name}
        </button>
      </div>

      <article className="post-detail">
        <div className="post-detail-meta">
          <span className="category-badge">
            {category.icon} {category.name}
          </span>
          <span className="post-time">{formatRelativeTime(post.createdAt)}</span>
        </div>

        <h1 className="post-detail-title">{post.title}</h1>

        <div className="post-author-info">
          <span className="author-avatar">
            {post.authorIsGuest ? "👤" : "👨‍💻"}
          </span>
          <span className="author-name">
            {post.authorIsGuest && <span className="guest-badge">Guest</span>}
            {post.authorName}
          </span>
        </div>

        <div className="post-detail-content">
          {post.content.split("\n").map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </article>

      <CommentSection postId={post.id} user={user} />
    </div>
  );
}

export default PostDetail;
